export function getEquipmentSchema() {
  return [
    {
      name: "id",
      default: "",
      type: "string",
      maxLength: 80,
      selectables: [],
      similair: [],
      helperText: "",
      nullable: false,
      readOnly: true,
      error: false,
    },
    {
      name: "Name",
      default: "",
      type: "string",
      maxLength: 80,
      selectables: [],
      similair: [
        "equiptment name",
        "equiptment id",
        "equiptment tag",
        "equiptment",
        "indentifier",
        "tag",
        "id",
        "label",
      ],
      nullable: false,
      readOnly: false,
      helperText: "",
      error: false,
    },
    {
      name: "Type",
      default: "",
      type: "string",
      maxLength: 80,
      selectables: [],
      similair: [
        "group",
        "group Name",
        "category",
        "category Name",
        "categories",
      ],
      helperText: "",
      nullable: false,
      readOnly: false,
      error: false,
    },
    {
      name: "Status",
      default: "",
      type: "string",
      maxLength: 80,
      selectables: [
        "On site",
        "Pending Install",
        "Operational",
        "Needs Repair",
      ],
      similair: [
        "status",
        "currently",
        "category",
        "category Name",
        "categories",
      ],
      helperText: "Current Status of the Equipment",
      nullable: false,
      readOnly: false,
      error: false,
    },
    {
      name: "Discipline",
      default: "",
      type: "string",
      maxLength: 80,
      selectables: [],
      similair: [
        "group",
        "group Name",
        "category",
        "category Name",
        "categories",
      ],
      helperText: "",
      nullable: true,
      readOnly: false,
      error: false,
    },
    {
      name: "System",
      default: "",
      type: "string",
      maxLength: 80,
      selectables: [],
      similair: [
        "group",
        "group Name",
        "category",
        "category Name",
        "categories",
      ],
      helperText: "",
      nullable: true,
      readOnly: false,
      error: false,
    },
    {
      name: "Space",
      default: "",
      type: "string",
      maxLength: 80,
      selectables: [],
      similair: ["room", "place", "location", "area"],
      helperText: "",
      nullable: true,
      readOnly: false,
      error: false,
    },
  ];
}
